import script from "./MarketingSection.vue?vue&type=script&setup=true&lang=js"
export * from "./MarketingSection.vue?vue&type=script&setup=true&lang=js"

import "./MarketingSection.vue?vue&type=style&index=0&id=70878002&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70878002"]])

export default __exports__